import { Outlet } from 'react-router-dom';
import clsx from 'clsx';
import type { CSSProperties, JSX } from 'react';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import { useApp } from '../../hooks/useApp';
import { THEME_PALETTE } from '../../../../../src/lib/theme';

// arbi-dev AppShell. Mirrors arbi root's AppShell minus SessionTabsBar
// (arbi-dev has no buying-session tabs concept). Theme + density classes
// applied to the wrapper div so all CSS-variable cascades work the same
// way as in arbi.
export default function AppShell(): JSX.Element {
  const { theme, density } = useApp();

  const themeVars = (THEME_PALETTE[theme] ?? THEME_PALETTE.dark) as CSSProperties;

  return (
    <div
      style={themeVars}
      className={clsx('flex flex-col h-screen overflow-hidden', theme, `density-${density}`)}
    >
      <TopBar />

      <div className="flex flex-1 min-h-0 overflow-hidden">
        <Sidebar />

        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <main className="flex-1 flex flex-col overflow-hidden bg-surface-0">
            <div className="flex-1 overflow-hidden p-4">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
